// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React from "react";
import { Formik, Form, Field } from "formik";
//import axios from "axios";
import TextField from "@material-ui/core/TextField";
import * as Yup from "yup";

import { Input } from "../../../../../../_metronic/_partials/controls";


// Validation schema
const GuiAwardEditSchema = Yup.object().shape({
  awardTitle: Yup.string().required("Name is required"),
});

//const PageUrl = `${process.env.REACT_APP_API_URL}/api/guide`;

export function GuiAwardEditForm({ guiAward, btnRef, saveGuiAward }) {
  // const [menuForDropdown, setMenuForDropdown] = useState([]);

  // useEffect(() => {
  //   const getInnerPagesWithAxios = async () => {
  //     const response = await axios.get(PageUrl);
  //     setMenuForDropdown(response.data);
  //   };
  //   getInnerPagesWithAxios();
  // }, [setMenuForDropdown]);

  const getFieldCSSClasses = (touched, errors) => {
    const classes = ["form-control"];
    if (touched && errors) {
      classes.push("is-invalid");
    }

    if (touched && !errors) {
      classes.push("is-valid");
    }

    return classes.join(" ");
  };
  const toBase64 = (uplaodDoc) =>
    new Promise((resolve, reject) => {
      if (uplaodDoc && uplaodDoc !== "" && uplaodDoc !== " ") {
        const reader = new FileReader();
        reader.readAsDataURL(uplaodDoc);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      } else {
        resolve("");
      }
    });
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={guiAward}
        validationSchema={GuiAwardEditSchema}
        onSubmit={(values) => {
          try {
            values.guideId = parseInt(values.guideId);
          } catch {}
          saveGuiAward(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, touched, errors }) => (
          <>
            <Form className="form form-label-right">
              <div className="form-group">
              Guide Id: {guiAward.guideId}
                {/* <Field
                  name="guideId"
                  component={Select}
                  placeholder="Guide Name"
                  label="Guide Name"
                  children={
                    menuForDropdown ? (
                      <>
                        <option value="0">None</option>
                        {menuForDropdown
                          .filter((menu) => menu.isActive)
                          .map((menu, index) => {
                            return (
                              <option key={index} value={menu.guideId}>
                                {menu.guideName}
                              </option>
                            );
                          })}
                      </>
                    ) : (
                      <option value="0">None</option>
                    )
                  }
                /> */}
              </div>
              <div className="form-group">
                <Field
                  name="awardTitle"
                  component={Input}
                  placeholder="Award Title"
                  label="Award Title"
                />
              </div>

              <div className="form-group">
                <TextField
                  id="date"
                  label="Award Date"
                  type="date"
                  name="awardDate"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFieldValue("awardDate", e.target.value);
                  }}
                />
              </div>

              <div className="form-group">
                <Field
                  name="remark"
                  component={Input}
                  placeholder="Remark"
                  label="Remark"
                />
              </div>
              {/* <div className="form-group">
                <Field
                  name="uplaodDoc"
                  component={Input}
                  placeholder="uplaodDoc"
                  label="uplaodDoc"
                />
              </div> */}

              <div className="form-group">
                <label>Select Upload Doc</label>
                <input
                  className={getFieldCSSClasses(
                    touched["uplaodDoc"],
                    errors["uplaodDoc"]
                  )}
                  name="uplaodDoc"
                  placeholder="Upload Doc"
                  label="Upload Doc"
                  type="file"
                  onChange={async (e) => {
                    setFieldValue(
                      "uplaodDoc",
                      await toBase64(e.target.files[0])
                    );
                  }}
                  accept="file"
                />
              </div>

              <div className="form-group">
                <Field
                  name="remark1"
                  component={Input}
                  placeholder="Remark 1"
                  label="Remark 1"
                />
              </div>

              <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}
              ></button>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
